import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Card = styled.div`
  max-width: 420px; margin: 60px auto; background: #fff; border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 24px; box-shadow: ${({ theme }) => theme.shadows.md};
`;
const Logo = styled.img`
  height: 80px; width: auto; margin: 0 auto 16px; display: block;
`;
const Title = styled.h1` margin: 0 0 16px; color: ${({ theme }) => theme.colors.green[700]}; text-align: center; `;
const Field = styled.div` margin-bottom: 12px; label{ display:block; margin-bottom:6px; } input{ width:100%; padding:10px; border:1px solid ${({ theme }) => theme.colors.gray[300]}; border-radius:8px; }`;
const Button = styled.button` width:100%; padding: 12px; border:none; border-radius: 10px; background: ${({ theme }) => theme.colors.green[600]}; color:#fff; font-weight:600; cursor:pointer; `;
const Back = styled.div` text-align:center; margin-top: 12px; a{ color: ${({ theme }) => theme.colors.green[600]}; }`;
const Error = styled.div` background:#fdeaea; color:#b91c1c; padding:10px; border-radius:8px; margin-bottom: 10px; border:1px solid #fca5a5; `;

const Login = () => {
  const { login } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/admin';

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const u = await login(form);
      if (u.role === 'foodBusiness') {
        navigate('/business-dashboard', { replace: true });
      } else {
        navigate(from, { replace: true });
      }
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <Logo src="/assests/logo/logo.jpeg" alt="FAL Logo" />
      <Title>Admin Login</Title>
      {error ? <Error>{error}</Error> : null}
      <form onSubmit={onSubmit}>
        <Field>
          <label htmlFor="username">Username</label>
          <input id="username" name="username" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
        </Field>
        <Field>
          <label htmlFor="password">Password</label>
          <input id="password" name="password" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
        </Field>
        <Button type="submit" disabled={loading}>{loading ? 'Logging in…' : 'Login'}</Button>
      </form>
      <Back>
        <Link to="/">← Back to Website</Link>
      </Back>
    </Card>
  );
};

export default Login;
